import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: var(--layer-fullpage-modal);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  width: 80vw;
  max-width: 320px;

  > div {
    > button {
      display: none;
    }
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 0 20px;
  gap: 20px;
  width: 80vw;
  max-width: 320px;
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    accent-color: #ff4d4f;
  }
`

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  background: transparent;
  color: #ffffff;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
